import { CmsPublicationView } from '../../../../components/Cms';

export function CmsPublicationDetail() {
  return <CmsPublicationView />;
}
